export default __webpack_public_path__ + "static/media/first.f6811f9e.png";